// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeRange_root__1Bc8o","date":"TimeRange_date__1sJIU"};